module.exports = __webpack_public_path__ + "static/media/listing-icon-active.73c33f94.svg";